module.exports = (parcelRequire.load("4ZnAe")).then(() => parcelRequire('jRy1T'));